<template>
    <the-header-menu />
    <el-container class="reusable-page">

      <div class="lnd-cover">
        <h1 class="lnd-headline">Zážitkové lety</h1>
      </div>

      <div class="main-content">
        <el-page-header content="Zážitkové lety" @back="goBack" title="Zpět"/>
        <div class="content">
          <h3>Chcete se podívat na Zemi z ptačí perspektivy?</h3>

          <span>
            Nabízíme zážitkové lety v ultralehkém letounu. V kabině s Vámi bude zkušený pilot – instruktor,
            takže se nemusíte ničeho bát. Všechny naše letadla splňují nejpřísnější provozní kritéria a jsou pravidelně servisovaná.
            Naši piloti mají ve vzduchu nalétány stovky hodin.
          </span>

          <h4>Zážitkový let ultralightem</h4>
          <span>
            Láká Vás nevšední zážitek? Chtěli byste věnovat netradiční dárek svému partnerovi, příbuznému či známému? Nabízíme Vám zážitkový let pro jednu osobu v motorovém letadle ultralehké kategorie. Ujme se Vás zkušený pilot, který s Vámi naplánuje individuální trasu, nebo Vám doporučí ta nejhezčí místa v okolí dle doby letu. Z vrchu můžete shlédnout na rodnou hroudu nebo se podívat za kopce k sousedům na Slovensko.
            Zážitkový let si můžete objednat telefonicky, nebo nám napište na naši emailovou adresu. Létáme po celý rok za příznivého počasí.
          </span>

          <div style="padding-top: 20px">
          <table>
            <tr>
              <th>Délka letu</th>
              <td>20 minut</td>
              <td>30 minut</td>
              <td>45 minut</td>
              <td>60 minut</td>
            </tr>
            <tr>
              <th>Cena</th>
              <td>1450,-</td>
              <td>2050,-</td>
              <td>2600,-</td>
              <td>3100,-</td>
            </tr>
          </table>
          </div>

          <h4 id="pilotemnazkousku">Pilotem na zkoušku</h4>
          <span >
            Máte zájem si vyzkoušet pilotáž letadla? Chtěli byste si vyzkoušet jaké to je sedět za kniplem a prohánět se oblohou? Tak právě Vám nabízíme příležitost stát se pilotem na zkoušku.
            Nejdříve Vám náš zkušený instruktor na zemi vše v klidu vysvětlí. Po předletové přípravě už nic nebrání tomu, abyste letadlo „protáhli“ ve vzduchu. Náš instruktor Vám přitom bude po celou dobu letu mentorem a parťákem, co Vás nenechá ve štychu. Navíc po přistání shrne, jak jste si za kniplem vedli a může Vás také seznámit s možnostmi pilotního výcviku.
          </span>

          <div style="padding-top: 20px">
          <table>
            <tr>
              <th>Délka letu</th>
              <td>20 minut</td>
              <td>30 minut</td>
              <td>45 minut</td>
              <td>60 minut</td>
            </tr>
            <tr>
              <th>Cena</th>
              <td>1650,-</td>
              <td>2250,-</td>
              <td>2800,-</td>
              <td>3300,-</td>
            </tr>
          </table>
          </div>




          <div class="vl-images-w">
            <el-carousel :interval="4000" type="card" height="200px" >
                <el-carousel-item v-for="i in photos_url" :key="i" @click="toggle()">
                    <!-- <el-image :src="i" :lazy="true"></el-image> -->
                    <img :src="i" loading="lazy" style="max-height:100%;">
                </el-carousel-item>
            </el-carousel>
          </div>

          <el-image-viewer v-if="viewer_toggled" :url-list="photos_url" @close='toggle()' :hide-on-click-modal='true' />
        </div>
      </div>
      <the-footer />
    </el-container>
</template>

<script>

import TheHeaderMenu from '../components/TheHeaderMenu3.vue'
import TheFooter from '../components/TheFooter.vue'

import { useRouter } from 'vue-router'
import { ref } from '@vue/reactivity'


export default {
    name: "PageVyhlidkoveLety",
    components: {
      TheHeaderMenu,
      TheFooter
    },
    setup(){
      const router = useRouter();

      const viewer_toggled = ref(false)
      const toggle = function(){
        viewer_toggled.value = !viewer_toggled.value;
      }      
      let photos_url = [];

      for(let img_n of [2,4,8,12,32]){
        photos_url.push(require("../../src/assets/photos/img"+String(img_n)+".jpg"))
      }



      function goBack(){
        router.back()
      }

      return {goBack, photos_url, viewer_toggled, toggle}
    }

}
</script>


<style scoped>

table {
  /* padding-top: 20px; */
  border-collapse: collapse;
  width: 100%;
}

td, th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

tr:nth-child(even) {
  background-color: #dddddd;
}


.main-content h4{
  padding-top: 15px;
}

.main-content{
  width: 90%;
  padding-top: 20px;
  padding-bottom: 30px;
}
.content{
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 30px;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
}

.lnd-cover{
  width: 100%;
  height: 300px;
  background-image: url("../../src/assets/cover/img20.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.lnd-headline{
  /* margin:auto; */
  /* line-height:51px; */
  text-align: center;
  position: relative;
  /* left: 50%; */
  top: 40%;
}

.reusable-page{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  height: 100%;
  width: 100%;
  
  /* background: rgb(227, 233, 227); */
}

.vl-images-w{
    width:100%;
    padding-top: 50px;
}

</style>